import './CircleSpinner.scss';

interface Props {
  size?: number;
  className?: string;
  color?: string;
}

const DEFAULT_SIZE = 24;

/**
 * Shared bordered rotating-circle loading spinner — the app's standard
 * loading indicator. Originally lived only in bid2earn (`.spinner` /
 * `Spinner()` in `routes/bid2earn/components/atoms.tsx`); extracted here so
 * every surface can render the same spinner.
 */
const CircleSpinner = ({ size = DEFAULT_SIZE, className = '', color = 'var(--accent-turquoise)' }: Props) => {
  const borderWidth = Math.max(2, Math.round(size / 8));

  return (
    <span
      className={`circle-spinner ${className}`.trim()}
      role="status"
      aria-label="Loading"
      style={{
        width: size,
        height: size,
        borderWidth,
        borderTopColor: color,
      }}
    />
  );
};

export default CircleSpinner;
